<template>
  <v-card :loading="loading" class="rounded-lg mb-2 pa-2 w-100" outlined>
    <v-card-title :class="reorderMode ? 'pt-1 px-1' : 'pt-2 px-2 pb-0'">
      <v-tooltip bottom v-if="showReorder && !loading && reorderMode">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon small class="handle mr-2" v-bind="attrs" v-on="on">
            <v-icon small>mdi-drag-vertical</v-icon>
          </v-btn>
        </template>
        <span>برای جابه‌جایی ترتیب متن‌ها آن را بکشید</span>
      </v-tooltip>
      <v-tooltip bottom v-if="showReorder && !loading && !reorderMode">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            small
            class="mr-2"
            v-bind="attrs"
            v-on="on"
            @click.stop="$emit('moveDown', index)"
            v-if="index !== totalItems - 1"
          >
            <v-icon small>mdi-arrow-down</v-icon>
          </v-btn>
        </template>
        <span>پایین</span>
      </v-tooltip>
      <v-tooltip bottom v-if="showReorder && !loading && !reorderMode">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            small
            class="mr-2"
            v-bind="attrs"
            v-on="on"
            @click.stop="$emit('moveUp', index)"
            v-if="index !== 0"
          >
            <v-icon small>mdi-arrow-up</v-icon>
          </v-btn>
        </template>
        <span>بالا</span>
      </v-tooltip>
      <div class="d-flex align-center">
        <img
          v-if="titleInfo.icon"
          :src="titleInfo.icon"
          width="24"
          height="24"
          style="object-fit: contain; margin-left: 8px"
        />
        <span class="mr-2">{{ titleInfo.text }}</span>
      </div>

      <div v-if="index === 0 && loading" class="pa-2 font-size-h6 red--text">
        درحال ارسال
        <v-progress-circular color="red" indeterminate size="20" width="2" />
      </div>
      <template v-else>
        {{ index + 1 }}
      </template>

      <v-spacer />

      <v-tooltip bottom v-if="showDelete && !loading">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="showDelete && !loading"
            :loading="loading"
            icon
            color="red"
            v-bind="attrs"
            v-on="on"
            @click="$emit('deleteRow')"
          >
            <v-icon color="red">mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>حذف</span>
      </v-tooltip>
    </v-card-title>
    <v-divider />

    <v-row no-gutters>
      <v-col v-if="reorderMode" cols="12" class="pa-4">
        <div class="d-flex align-center">
          <strong class="text-h6">{{ index + 1 }}.</strong>
          <img
            :src="messageIcon"
            width="28"
            height="28"
            style="object-fit: contain; border-radius: 6px; margin-left: 8px"
            alt=""
          />
          <div class="mx-3 flex-grow-1">
            <div class="font-weight-bold">
              {{ computedItem.title || "بدون عنوان" }}
            </div>
            <div class="grey--text text--darken-1 mt-1">
              {{
                computedItem.text
                  ? computedItem.text.substring(0, 100) + "..."
                  : "بدون متن"
              }}
            </div>
          </div>
        </div>
      </v-col>
      <template v-else>
        <v-col v-if="Object.hasOwn(item, 'date')" class="pa-2" cols="12" md="6">
          <date-picker
            v-model="computedItem.date"
            :label="$t('FORMS.SendTime')"
            :min="nowDateTimeString()"
            auto-submit
            display-format="jYYYY-jMM-jDD HH:mm:ss"
            format="YYYY-MM-DD HH:mm:ss"
            type="datetime"
          />

          <span v-show="!computedItem.date" class="red--text"
            >انتخاب تاریخ الزامی است.</span
          >
        </v-col>

        <v-col v-else-if="index !== 0" class="pa-2" cols="12" md="6">
          <v-text-field
            v-model.number="computedItem.gap"
            :min="gapMinMax.min"
            :max="gapMinMax.max"
            :suffix="gapSuffix"
            clearable
            dense
            hide-spin-buttons
            label="فاصله زمانی"
            outlined
            placeholder="فاصله زمانی از پیام قبلی"
            type="number"
            class="gap-input-with-icon"
            @input="limitGapValue"
          >
            <template v-slot:append>
              <v-menu offset-y open-on-click close-on-content-click>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small v-bind="attrs" v-on="on" class="ml-1">
                    <v-icon small>
                      {{ getGapIcon(computedItem.type) }}
                    </v-icon>
                  </v-btn>
                </template>

                <v-card max-width="300" class="pa-2">
                  <v-item-group v-model="computedItem.type" mandatory>
                    <div class="d-flex flex-wrap ga-2 flex-column">
                      <v-item
                        v-for="item in gapItems"
                        :key="item.value"
                        :value="item.value"
                        v-slot="{ active, toggle }"
                      >
                        <v-chip
                          :color="active ? 'primary' : 'grey lighten-3'"
                          :text-color="active ? 'white' : ''"
                          small
                          @click="toggle"
                          class="ma-1"
                        >
                          <v-icon small left>{{
                            getGapIcon(item.value)
                          }}</v-icon>
                          {{ item.text }}
                        </v-chip>
                      </v-item>
                    </div>
                  </v-item-group>
                </v-card>
              </v-menu>
            </template>
          </v-text-field>
        </v-col>
        <v-col
          :md="!!Object.hasOwn(item, 'date') || index > 0 ? 6 : 12"
          class="pa-2"
          cols="12"
        >
          <send-operator-picker
            v-if="
              ribbon_can('all_numbers') || !$route.path.includes('campaign')
            "
            v-model="computedItem.Operator"
            :message-type="'sms_text'"
          />
          <send-operator-picker
            v-else
            v-model="computedItem.OperatorDisplay"
            :message-type="'sms_text'"
          />
        </v-col>

        <v-col class="pa-2" cols="12">
          <v-text-field
            v-model="computedItem.title"
            :placeholder="$t('FORMS.Title')"
            class="pt-0 mt-0"
            dense
            hide-selected
            label="عنوان"
            outlined
          />
        </v-col>

        <v-col v-if="tracking" class="pa-2" cols="12">
          <v-divider />
          <v-text-field
            v-model="computedItem.link"
            :rules="rules.link"
            clear-icon="mdi-close-circle-outline"
            clearable
            dense
            hint="any"
            label="وارد کردن لینک"
            outlined
            persistent-hint
            placeholder="مثال‌:[](https://example.ex/any)"
            @update:error="(e) => (linkErrors = e)"
          >
            <template v-if="!linkErrors" v-slot:message>
              لینک شما پس از کوتاه شدن به
              <span class="primary--text">طول ۱۴ حرف</span>
              جایگزین
              <span class="primary--text">(example.ex/any)</span>
              داخل متن قرار گرفته و لینک اختصاصی برای هر پیام ارسال خواهد شد.
            </template>
            <template v-slot:append>
              <v-icon v-if="!linkErrors && !!computedItem.link" color="green"
                >mdi-check</v-icon
              >
            </template>
          </v-text-field>
        </v-col>
        <v-col class="pa-2" cols="12">
          <suggest-text
            v-model="computedItem.text"
            :label="$t('FORMS.Text')"
            :rules="rules.text"
            :text-suggest="textSuggest"
            @openCamp="$emit('openCamp')"
            @textInfo="
              (e) => {
                computedItem.msgCount = e.smsCount;
                computedItem.lang = e.lang.name;
              }
            "
          />
        </v-col>
      </template>
    </v-row>
  </v-card>
</template>

<script>
import SuggestText from "@/view/components/SuggestBox/suggestInput.vue";
import { mapGetters } from "vuex";
import SendOperatorPicker from "./sendOperatorPicker.vue";

export default {
  name: "campaignListItem",

  components: {
    SendOperatorPicker,
    SuggestText,
  },

  props: {
    messageTypes: { type: Array, default: () => [] },
    item: Object,
    index: Number,
    loading: Boolean,
    textSuggest: {
      type: Boolean,
      default: true,
    },
    titleInfo: {
      type: Object,
      default: () => ({
        text: "پیامک متنی",
        icon: "/media/socialIcon/sms.webp",
      }),
    },
    showDelete: Boolean,
    showReorder: Boolean,
    tracking: Boolean,
    reorderMode: {
      type: Boolean,
      default: false,
    },
    totalItems: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      linkErrors: false,
      rules: {
        text: [
          (n) => !!n || this.$t("ERRORS.EmptyText"),
          (n) =>
            n.includes(this.sendTextPattern) ||
            `بایستی شامل عبارت ${this.sendTextPattern} باشد`,
        ],
        link: [(n) => this.isDomain(n) || "لینک صحیح وارد نمایید"],
      },
      gapItems: [
        { value: "min", text: "دقیقه", min: 1, max: 60 },
        { value: "hour", text: "ساعت", min: 1, max: 24 },
        { value: "day", text: "روز", min: 1, max: 30 },
        { value: "week", text: "هفته", min: 1, max: 4 },
      ],
    };
  },

  computed: {
    ...mapGetters("locals", ["sendTextPattern"]),
    computedItem: {
      get() {
        return this.item;
      },
      set(val) {
        this.$emit("update:item", val);
      },
    },
    gapSuffix() {
      return this.computedItem.type
        ? this.gapItems.find((item) => item.value === this.computedItem.type)
            ?.text
        : "";
    },
    gapMinMax() {
      return this.computedItem.type
        ? this.gapItems.find((item) => item.value === this.computedItem.type)
        : {
            min: 0,
            max: 24,
          };
    },
    messageIcon() {
      return "/media/socialIcon/sms.webp";
    },
  },
  methods: {
    getGapIcon(type) {
      const icons = {
        min: "mdi-clock-outline",
        hour: "mdi-clock-time-four-outline",
        day: "mdi-calendar-today",
        week: "mdi-calendar-week",
      };
      return icons[type] || "mdi-calendar-clock";
    },

    limitGapValue() {
      if (!this.computedItem.type) return;

      if (this.computedItem.gap > this.gapMinMax.max) {
        this.computedItem.gap = this.gapMinMax.max;
      } else if (this.computedItem.gap < this.gapMinMax.min) {
        this.computedItem.gap = this.gapMinMax.min;
      }
    },
    isDomain(str) {
      var regex = new RegExp(
        "^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?",
      );
      return !str || regex.test(str) || str.length <= 0;
    },
  },
};
</script>

<style scoped>
.reorder-item {
  border: 2px solid transparent;
  border-color: #8b8b8b;
  margin-left: 4px;
  margin-right: 4px;
}

.reorder-item:hover {
  transition: all 0.3s ease;
  cursor: grab;
  border: 2px dashed transparent;
  border-color: #76b9fc;
  background-color: #d8e8fd !important;
}

.reorder-item .handle {
  cursor: grabbing;
}
.handle {
  cursor: grab;
  margin-left: 10px;
}
</style>
